export default __webpack_public_path__ + "pypi/stlite_server-0.1.0-py3-none-any.whl";